import React from 'react'
import { Sentry } from 'utils/sentry'

function FallbackComponent() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Something went wrong.</h2>
      <p>Please refresh the page or contact support if the problem persists.</p>
      <button onClick={() => window.location.reload()}>Refresh</button>
    </div>
  )
}

export default function ErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={<FallbackComponent />}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
